var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10.267,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2d3e5c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21796",
    d: "M13.974 4.975A7.789 7.789 0 0 0 7 0 7.789 7.789 0 0 0 .028 4.975a.467.467 0 0 0 0 .317A7.789 7.789 0 0 0 7 10.267a7.789 7.789 0 0 0 6.974-4.975.467.467 0 0 0 0-.317ZM7 9.334a6.93 6.93 0 0 1-6.034-4.2A6.929 6.929 0 0 1 7 .934a6.929 6.929 0 0 1 6.034 4.2A6.93 6.93 0 0 1 7 9.334Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21797",
    d: "M7 2.333a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8ZM7 7a1.867 1.867 0 1 1 1.867-1.867A1.867 1.867 0 0 1 7 7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoView);
export default __webpack_public_path__ + "static/media/Video_view.29204727eb148209d2883533f86a58af.svg";
export { ForwardRef as ReactComponent };